<template>
  <div class="signature-wrapper" v-click-outside="hideDropdown">
    <button class="signature-btn" @click="showDropdown" >
      <svg class="signature-btn__icn" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.7707 2.97474C10.5618 1.45038 12.4389 0.855971 13.9632 1.64709L14.6405 1.99859C16.1649 2.78971 16.7593 4.66677 15.9682 6.19114L15.8932 6.33555C15.8972 6.3385 15.9011 6.34146 15.9051 6.34443C15.9205 6.35596 15.9361 6.36765 15.9519 6.3795C16.1327 6.51502 16.3398 6.67176 16.5298 6.84494C16.9047 7.18662 17.3217 7.68911 17.3352 8.40735C17.341 8.71529 17.272 9.02884 17.1211 9.31947L15.3082 12.8128C15.1301 13.156 14.7075 13.2898 14.3644 13.1117C14.0213 12.9336 13.8874 12.5111 14.0655 12.1679L15.8785 8.67457C15.9192 8.59618 15.9369 8.51405 15.9354 8.43361C15.9328 8.29208 15.8603 8.12894 15.5868 7.87966C15.4846 7.78659 15.3694 7.69481 15.2393 7.59563L11.5933 14.6208C11.5761 14.654 11.5563 14.6857 11.534 14.7157L10.972 14.2984C11.534 14.7157 11.534 14.7157 11.534 14.7157L11.5291 14.7223L11.5164 14.7393L11.4687 14.8026C11.4274 14.8572 11.3674 14.9358 11.2921 15.0332C11.1415 15.2278 10.9286 15.4981 10.6786 15.8021C10.1841 16.4033 9.52359 17.1617 8.90537 17.721C8.07335 18.4737 6.74511 19.3819 6.00648 19.8707C5.2923 20.3432 4.34351 19.8508 4.31883 18.9948C4.29331 18.1095 4.27141 16.5006 4.408 15.3869C4.5095 14.5595 4.74945 13.5828 4.95643 12.8324C5.06108 12.453 5.15959 12.1233 5.23202 11.8881C5.26827 11.7705 5.29807 11.6762 5.31894 11.611L5.34326 11.5355L5.34983 11.5153L5.35213 11.5083C5.35215 11.5083 5.35238 11.5076 6.01715 11.7269L5.35213 11.5083C5.36384 11.4728 5.37862 11.4376 5.39584 11.4044L9.7707 2.97474ZM6.85327 11.6354L11.0133 3.61964C11.4483 2.78156 12.4803 2.45476 13.3183 2.88971L13.9956 3.24121C14.8337 3.67616 15.1605 4.70816 14.7256 5.54624L10.5379 13.6152C9.74703 13.5817 8.23496 13.1901 6.85327 11.6354ZM6.33294 13.1077C6.32403 13.1396 6.31506 13.1719 6.30604 13.2046C6.10334 13.9395 5.88613 14.8355 5.79759 15.5574C5.69874 16.3633 5.6911 17.5071 5.70543 18.3869C6.43307 17.8922 7.36397 17.2276 7.96613 16.6828C8.50543 16.1949 9.11307 15.5015 9.59733 14.9128C9.60148 14.9077 9.60562 14.9027 9.60975 14.8977C8.64129 14.6863 7.45561 14.1654 6.33294 13.1077ZM10.2812 19.7471C9.65133 20.1693 8.88718 20.7706 8.37375 21.1984C8.07675 21.4459 7.63536 21.4058 7.38786 21.1088C7.14037 20.8118 7.18049 20.3704 7.47749 20.1229C8.00825 19.6806 8.8144 19.0449 9.50179 18.5842C9.83603 18.3602 10.1852 18.1479 10.4754 18.0316C10.5994 17.9819 10.8257 17.9009 11.0705 17.9273C11.2126 17.9426 11.4099 17.9999 11.5731 18.1695C11.7374 18.3401 11.7883 18.5422 11.7971 18.6918C11.8041 18.8094 11.8019 18.932 11.7993 19.0352C11.7985 19.066 11.7976 19.0954 11.7968 19.1237C11.7947 19.1991 11.7927 19.2675 11.7924 19.339C11.7919 19.4523 11.7967 19.5343 11.8038 19.5923C11.8132 19.5908 11.8234 19.5891 11.8343 19.5871C11.9311 19.569 12.0688 19.5291 12.2564 19.4514C12.414 19.3862 12.5729 19.3193 12.7311 19.2527C13.4012 18.9705 14.0602 18.6929 14.5678 18.5677C14.8635 18.4947 15.2819 18.4238 15.6593 18.5771C15.8766 18.6653 16.065 18.8217 16.1878 19.0452C16.303 19.2546 16.3366 19.4785 16.3366 19.6766C16.3366 19.7939 16.3392 19.8808 16.3466 19.9507C16.348 19.9638 16.3495 19.9756 16.351 19.9861C16.4666 19.9983 16.7033 19.9894 17.1368 19.8875C17.6161 19.7748 18.2706 19.5651 19.1612 19.2238C19.5222 19.0854 19.927 19.2658 20.0653 19.6268C20.2037 19.9878 20.0233 20.3926 19.6623 20.531C18.7456 20.8824 18.0246 21.117 17.4571 21.2503C16.9059 21.3799 16.4264 21.4326 16.0288 21.3515C15.8179 21.3084 15.6141 21.2247 15.4379 21.0822C15.26 20.9384 15.1443 20.7622 15.0712 20.5852C14.9793 20.3628 14.9501 20.1221 14.9409 19.9179C14.9288 19.9207 14.9163 19.9237 14.9031 19.9269C14.513 20.0231 13.9938 20.2413 13.336 20.5176C13.1641 20.5898 12.9827 20.666 12.7917 20.7451C12.3141 20.9427 11.8533 21.0531 11.438 20.9734C10.9457 20.8789 10.6543 20.5493 10.5177 20.1937C10.4503 20.0182 10.4186 19.8337 10.4041 19.666C10.3645 19.6917 10.3235 19.7188 10.2812 19.7471ZM14.9354 19.6528C14.9355 19.6528 14.9356 19.6534 14.9357 19.6545L14.9354 19.6528Z" fill="#094172"/>
      </svg>
      <span class="signature-btn__text">{{getSignatureName}}</span>
      <svg class="arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.72443 4.39844C2.45716 4.39844 2.32331 4.72158 2.5123 4.91057L5.78804 8.18631C5.9052 8.30346 6.09515 8.30346 6.21231 8.18631L9.48803 4.91057C9.67702 4.72158 9.54317 4.39844 9.2759 4.39844H2.72443Z" fill="#094172"/>
      </svg>
      <div class="signature-dropdown" v-if="dropdownVisible">
        <button class="signature-dropdown__settings" @click="showSettings">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.15258 4.90062C9.24388 4.21538 9.84767 3.74219 10.5078 3.74219H13.493C14.1555 3.74219 14.7578 4.21772 14.8494 4.90566L15.0531 6.28848C15.216 6.37189 15.376 6.46263 15.5326 6.56035L16.9044 6.02408L16.9132 6.0209C17.5702 5.78495 18.2622 6.05071 18.5864 6.61886L20.0761 9.1287L20.0803 9.1362C20.4081 9.72208 20.2732 10.4563 19.7335 10.8716L19.7307 10.8737L18.5913 11.7411C18.5954 11.8243 18.5977 11.9109 18.5977 11.9999C18.5977 12.089 18.5953 12.1757 18.5911 12.2587L19.7295 13.1255L19.7334 13.1285C20.2679 13.5417 20.4117 14.2738 20.083 14.8589L20.0791 14.8658L18.5834 17.3881C18.3408 17.8137 17.8814 18.0673 17.399 18.0673C17.2285 18.0673 17.0626 18.0362 16.9056 17.9768L16.8988 17.9742L15.5303 17.4391C15.3725 17.5376 15.2141 17.628 15.054 17.7106L14.8495 19.1004C14.7581 19.7865 14.1529 20.2589 13.4936 20.2589H10.5084C9.84418 20.2589 9.24332 19.7823 9.15193 19.094L8.94823 17.7115C8.78559 17.6281 8.62592 17.5375 8.46958 17.44L7.09722 17.9765L7.08794 17.9798C6.42628 18.2165 5.73896 17.9473 5.41573 17.3818L3.92608 14.872L3.92202 14.8648C3.59389 14.2796 3.72797 13.5456 4.26708 13.1295L4.27066 13.1267L5.41034 12.2592C5.40592 12.1711 5.40367 12.0852 5.40367 12.0006C5.40367 11.9161 5.40591 11.8304 5.4103 11.7424L4.26846 10.8729C3.7319 10.4589 3.57721 9.70598 3.9331 9.11627L5.41866 6.61345C5.75036 6.03143 6.48521 5.79425 7.09516 6.0238L7.10324 6.02684L8.47182 6.56202C8.62939 6.46368 8.78789 6.37327 8.94808 6.2907L9.15258 4.90062ZM10.4883 5.09642L10.177 7.21268L9.83468 7.36281C9.53889 7.49254 9.24248 7.65988 8.93579 7.87252L8.64028 8.07741L6.61957 7.28731C6.61871 7.28713 6.61674 7.28682 6.61351 7.28683C6.60755 7.28684 6.59999 7.28798 6.59239 7.29062C6.5893 7.2917 6.58671 7.29286 6.58467 7.29391L5.09425 9.80492L6.82395 11.122L6.7836 11.5003C6.76282 11.695 6.75367 11.8557 6.75367 12.0006C6.75367 12.1453 6.76284 12.3061 6.78363 12.5018L6.8238 12.8799L5.09545 14.1955C5.09592 14.197 5.09664 14.1988 5.09774 14.2011L6.5839 16.705L6.5877 16.7117C6.58873 16.7135 6.58951 16.7141 6.59085 16.7146C6.59162 16.7148 6.59421 16.7157 6.59952 16.7157C6.60404 16.7157 6.61329 16.7151 6.62758 16.7106L8.64136 15.9234L8.93771 16.1314C9.22569 16.3336 9.52621 16.5034 9.83496 16.639L10.1769 16.7892L10.4886 18.9044C10.4924 18.9065 10.4989 18.9089 10.5084 18.9089H13.4936C13.5026 18.9089 13.5093 18.9067 13.5138 18.9044L13.825 16.7897L14.1664 16.6393C14.463 16.5087 14.759 16.3417 15.066 16.1287L15.3616 15.9236L17.3853 16.7148C17.3909 16.7168 17.3947 16.7173 17.399 16.7173C17.405 16.7173 17.4103 16.7157 17.4138 16.7137L17.4144 16.7126L18.9068 14.1959L17.177 12.8787L17.2179 12.4999C17.2345 12.3459 17.2477 12.1753 17.2477 11.9999C17.2477 11.8234 17.235 11.6528 17.2182 11.5024L17.1756 11.1221L18.9064 9.80461C18.9059 9.80315 18.9052 9.80128 18.9041 9.79901L17.418 7.29519L17.414 7.28815C17.4138 7.28795 17.4126 7.28684 17.4111 7.28628C17.4097 7.28578 17.4067 7.28488 17.4013 7.28487C17.3967 7.28486 17.388 7.28548 17.3749 7.28963L15.3605 8.0771L15.0641 7.86886C14.7756 7.66614 14.4754 7.49654 14.1673 7.3618L13.8246 7.21187L13.5131 5.09694C13.509 5.09465 13.5024 5.09219 13.493 5.09219H10.5078C10.4991 5.09219 10.4926 5.09423 10.4883 5.09642ZM18.915 9.80786L18.9108 9.81034L18.9081 9.80584" fill="#2C2C2C"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9997 10.1781C10.9938 10.1781 10.1747 10.9972 10.1747 12.0031C10.1747 13.0091 10.9938 13.8281 11.9997 13.8281C13.0057 13.8281 13.8247 13.0091 13.8247 12.0031C13.8247 10.9972 13.0057 10.1781 11.9997 10.1781ZM8.82471 12.0031C8.82471 10.2516 10.2482 8.82812 11.9997 8.82812C13.7512 8.82812 15.1747 10.2516 15.1747 12.0031C15.1747 13.7547 13.7512 15.1781 11.9997 15.1781C10.2482 15.1781 8.82471 13.7547 8.82471 12.0031Z" fill="#2C2C2C"/>
          </svg>
          Signature Settings
        </button>
        <div class="signature-dropdown-content" >
          <button class="signature-dropdown__btn" :class="{active: !checkedSignature}" @click="checkSignature(null)">
            <span>Without a signature</span>
            <svg class="check-icn" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.9783 6.2675C17.6651 5.91943 17.1483 5.90978 16.8239 6.24594C16.8172 6.25297 16.8105 6.26016 16.8039 6.2675L10.535 14.8915L7.38355 12.2611C7.05922 11.9249 6.54241 11.9345 6.22918 12.2826C5.92361 12.6222 5.92361 13.1604 6.22918 13.5L9.95778 16.7499C10.2766 17.092 10.7934 17.092 11.1121 16.7499L17.9582 7.50645C18.2826 7.17023 18.2915 6.61558 17.9783 6.2675Z" fill="#319FEF"/>
            </svg>
          </button>
          <button
            v-for="signature in getSignatures" 
            :key="signature.id" 
            class="signature-dropdown__btn" 
            :class="{active: checkedSignature == signature.id}" 
            @click="checkSignature(signature.id)">
            <span>{{signature.content}}</span>
            <svg class="check-icn" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.9783 6.2675C17.6651 5.91943 17.1483 5.90978 16.8239 6.24594C16.8172 6.25297 16.8105 6.26016 16.8039 6.2675L10.535 14.8915L7.38355 12.2611C7.05922 11.9249 6.54241 11.9345 6.22918 12.2826C5.92361 12.6222 5.92361 13.1604 6.22918 13.5L9.95778 16.7499C10.2766 17.092 10.7934 17.092 11.1121 16.7499L17.9582 7.50645C18.2826 7.17023 18.2915 6.61558 17.9783 6.2675Z" fill="#319FEF"/>
            </svg>
          </button>
        </div>
      </div>
    </button>
    <SignatureSettingsModal
      ref="signatureSettingsModal"
      @updateSignatures="updateSignatures"
    ></SignatureSettingsModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SignatureSettingsModal from "@/components/mailbox/SignatureSettingsModal"
  export default {
    name: "signatureComponent",
    props: {
      accountInfo: {default: null}
    },
    components: {SignatureSettingsModal},
    data: () => ({
      dropdownVisible: false,
      checkedSignature: null
    }),
    methods: {
      showDropdown(){
        this.dropdownVisible = true;
      },
      hideDropdown(){
        this.dropdownVisible = false;
      },
      checkSignature(signatureId){
        this.checkedSignature = signatureId;
        let data = {signature: this.checkedSignature, id: this.accountInfo.id}
        let signature = this.getSignatures.find(el => el.id == signatureId)

        if(signature){
          data.content = signature.content
          data.top_content = signature.top_content
        }
        this.hideDropdown()
        // console.log('data::: ', data);
        this.$emit('updateSignature', data)
      },
      showSettings(){
        this.$refs.signatureSettingsModal.showModal(this.getSignatures)
        this.hideDropdown()
      },
      resetSignature(){
        // this.checkedSignature = null
        this.checkSignature(null)
      },
      startComponent(){
        if(this.accountInfo.signature){
          this.checkedSignature = this.accountInfo.signature.id
        }else{
          this.checkedSignature = null;
        }
      },
      updateSignatures(){
        if(this.checkedSignature) this.checkSignature(this.checkedSignature)
      }
    },
    mounted(){
      this.startComponent()
    },
    computed: {
      ...mapGetters(['getSignatures']),
      getSignatureName(){
        if(this.checkedSignature){
          let currentSignature = this.getSignatures.find(el => el.id == this.checkedSignature)
          if(currentSignature){
            return currentSignature.content
          }else{
            this.resetSignature()
            return 'Without a signature'
          }
          
        }else{
          return 'Without a signature'
        }
      }
    },
    watch: {
      accountInfo: function(){
        this.startComponent()
      }
    }
  }
</script>

<style lang="scss" scoped>
.signature-wrapper{
  position: relative;
  .signature-btn{
    display: flex;
    align-items: center;
    column-gap: 4px;
    max-width: 180px;
    *{
      transition: .3s;
    }
    .signature-btn__text{
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      color: var(--color-blue-dark);
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .arrow{
      min-width: 12px;
    }
    .signature-btn__icn{
      min-width: 24px;
    }
    &:hover{
      .signature-btn__text{
        color: var(--color-blue);
      }
      .signature-btn__icn, .arrow{
        path{
          fill: var(--color-blue)
        }
      }
    }
  }
  .signature-dropdown{
    position: absolute;
    right: 0;
    top: 50%;
    // height: 50px;
    width: 325px;
    background: var(--color-white);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    padding: 4px 0;
  }
  .signature-dropdown{
    .signature-dropdown__settings{
      border-bottom: 1px solid var(--color-head-table);
      width: 100%;
      height: 32px;
      display: flex;
      align-items: center;
      padding: 0 12px;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      column-gap: 4px;
      &:hover{
        color: var(--color-blue);
        svg{
          path{
            fill: var(--color-blue)
          }
        }
      }
    }
    .signature-dropdown-content{
      display: flex;
      flex-direction: column;
      padding-top: 4px;
      max-height: 320px;
      overflow-y: auto;
      height: auto;
    }
    .signature-dropdown__btn{
      width: 100%;
      height: 32px;
      min-height: 32px;
      display: flex;
      align-items: center;
      padding: 0 12px;
      &:hover{
        background: var(--color-gray-lightest);
      }
      &.active{
        background: var(--color-blue-gray-list);
        .check-icn{
          display: flex;
        }
      }
      .check-icn{
        min-width: 24px;
        margin-left: auto;
        display: none;
      }
      span{
        max-width: 100%;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        
      }
    }
  }
}
</style>